import { FC } from 'react'
import { SignUpForm } from './SignupForm'
import { fixedCacheKey } from './SignUpPassCode/hooks/useSendPassCode'
import { usePostApiV1AccountsConfirmEmailMutation } from '@wellesley/openapi'
import { TooManyAttempt } from '../TooManyAttempt'
import { SignUpStages } from './SignUpStages'

export const SignupSection: FC = () => {
  const [, { isError, error }] = usePostApiV1AccountsConfirmEmailMutation({
    fixedCacheKey,
  })

  return (
    <div className="flex flex-col items-center justify-center">
      <TooManyAttempt isError={isError} error={error} />
      <SignUpStages position={2} />
      <SignUpForm />
    </div>
  )
}
